import axiosConfig from '@lib/axiosConfig';


export const OmbudsmanCategoryService = {

    list: async function () {
        return await axiosConfig.get('/ombudsman-categories');
    },

    show: async function (id) {
        return await axiosConfig.get(`/ombudsman-categories/show/${id}`);
    },

    fetchbyfilter: async function (filter, order=null, limit=null) {
        return await axiosConfig.get(`/ombudsman-categories/fetchbyfilter/${filter}/${order}/${limit}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/ombudsman-categories/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/ombudsman-categories/update/${id}`, data);
    },

    delete: async function (id) {
        return await axiosConfig.delete(`/ombudsman-categories/delete/${id}`);
    },

};